
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Property from "./pages/Property";
import NotFound from "./pages/NotFound";
// import Test from "./pages/Test";
import { HelmetProvider } from "react-helmet-async";
import SentryWrapper from "./components/SentryWrapper";

const queryClient = new QueryClient();

const App = () => (
  <SentryWrapper>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              {/* TODO(getlost-web#47): public profile home routes disabled while the
                  listing endpoint behind them is unavailable. Re-enable alongside the
                  migration tracked by getlost-web#2. */}
              {/* <Route path="/" element={<Profile />} /> */}
              <Route path="/:profile/property/:uid" element={<Property />} />
              {/* <Route path="/:profile" element={<Profile />} /> */}
              <Route path="/notfound" element={<NotFound />} />
              
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </SentryWrapper>
);

export default App;
